const smoothScrolling = (position) => window.scroll({
  top: position,
  left: 0,
  behavior: 'smooth'
});

export default smoothScrolling